export enum Pagination {
  CURRENT_PAGE = 1,
  PAGE_SIZE = 20,
}
